import { IDB_calendarEventsReadAll } from '../IDB/IDB.table.calendarEvent'

/**
 * Cale.unsyncedEvents
 * This includes calendar events that are new or have been updated or deleted
 */
export async function Cale_unsyncedEvents() {
    const calendarEvents = await IDB_calendarEventsReadAll()
    const unsyncedCalendarEvents = calendarEvents.filter((calendarEvent) => {
        if (calendarEvent.onlineId == null) return true
        if (calendarEvent.meta == null) return false
        return calendarEvent.meta.new || calendarEvent.meta.updated || calendarEvent.meta.delete
    })

    return unsyncedCalendarEvents
}
